<template>
  <div class="q-pa-md q-gutter-sm">
    <q-breadcrumbs>
      <q-breadcrumbs-el icon="home" to="/" />
      <q-breadcrumbs-el label="供应商管理" icon="widgets" to="/supplier" />
      <q-breadcrumbs-el
        label="供应商详情"
        icon="widgets"
        to="/supplier/detail"
      />
    </q-breadcrumbs>

    <div class="row q-gutter-md justify-center">
      <div class="col-11" style="text-align: center">
        <h5>供应商信息</h5>
      </div>
      <div class="col-11">
        <q-input v-model="supplier.supplierName" label="供应商名称">
          <template v-slot:prepend>
            <q-icon name="account_balance" />
          </template>
        </q-input>
      </div>
      <div class="col-11">
        <q-input v-model="supplier.supplierShortName" label="供应商简称">
          <template v-slot:prepend>
            <q-icon name="account_box" />
          </template>
        </q-input>
      </div>
      <div class="col-11">
        <q-input v-model="supplier.mainBusiness" label="主营业务">
          <template v-slot:prepend>
            <q-icon name="business_center" />
          </template>
        </q-input>
      </div>
      <div class="col-11">
        <q-input v-model="supplier.taxNo" label="税号" clearable> </q-input>
      </div>
      <div class="col-11">
        <q-input v-model="supplier.address" label="地址" clearable>
          <template v-slot:prepend>
            <q-icon name="place" />
          </template>
        </q-input>
      </div>
      <div class="col-11">
        <q-input v-model="supplier.telephone" label="电话" clearable> </q-input>
      </div>
      <div class="col-11">
        <q-input v-model="supplier.openBank" label="开户行" clearable>
        </q-input>
      </div>
      <div class="col-11">
        <q-input v-model="supplier.account" label="帐号" clearable> </q-input>
      </div>
      <div class="col-11">
        <q-input v-model="supplier.bankNo" label="行号" clearable> </q-input>
      </div>
      <div class="col-11">
        <q-input v-model="supplier.contact" label="联系人">
          <template v-slot:prepend>
            <q-icon name="contact_phone" />
          </template>
        </q-input>
      </div>
      <div class="col-11 q-gutter-x-md" style="text-align: center">
        <q-btn label="保存" color="primary" @click="save" />
        <q-btn flat label="取消" color="primary" @click="cancel" />
      </div>
    </div>
  </div>
</template>

<script>
import { save, update, detail } from "@/api/erp/supplier";
export default {
  data() {
    return {
      supplier: {},
    };
  },
  methods: {
    save() {
      var self = this;
      if (self.supplier.id) {
        update(self.supplier).then((response) => {
          if (response.data.errorCode == "00000") {
            self.$q.notify({ type: "positive", message: "更新成功" });
          } else {
            self.$q.notify({
              type: "negative",
              message: response.data.errorMsg,
            });
          }
        });
      } else {
        save(self.supplier).then((response) => {
          if (response.data.errorCode == "00000") {
            self.$router.push({
              path: "/supplier/detail",
              query: { id: response.data.data },
            });
            self.$q.notify({ type: "positive", message: "保存成功" });
          } else {
            self.$q.notify({
              type: "negative",
              message: response.data.errorMsg,
            });
          }
        });
      }
    },
    cancel() {
      this.$router.push("/supplier");
    },
  },
  mounted() {
    let id = this.$route.query.id;
    var self = this;
    if (id) {
      detail(id).then((response) => {
        if (response.data.errorCode == "00000") {
          self.supplier = response.data.data;
        }
      });
    }
  },
};
</script>

<style scoped>
</style>